<template>
  <div id="SolarPlantsB2b">
    <Hero class="lift" src="../../../assets/b2b/hero.jpg">
      <Row>
        <Column :lg="7">
          <h1 class="title">
            {{ $t('title') | lineBreak }}
          </h1>
        </Column>
        <Column :lg="5">
          <p>{{ $t('side') }}</p>
        </Column>
      </Row>
    </Hero>
    <WhyUsAsPartners />
    <TypesOfPlantsForCompany />
    <FormContactB2b />
    <SectionGuarantees :ctaTo="{ name: $route.name, hash: '#FormContactB2b' }" />
    <SectionOptimisedSystem :ctaTo="{ name: $route.name, hash: '#FormContactB2b' }" />
  </div>
</template>

<script>
import FormContactB2b from './components/FormContactB2b'
import Hero from 'views/components/Hero'
import Meta from 'views/mixins/Meta'
import SectionGuarantees from 'views/components/SectionGuarantees'
import SectionOptimisedSystem from 'views/components/SectionOptimisedSystem'
import TypesOfPlantsForCompany from './components/TypesOfPlantsForCompany'
import WhyUsAsPartners from './components/WhyUsAsPartners'
import { getters } from 'views/utils'

export default {
  mixins: [
    Meta(require('@/assets/social/solar.jpg')),
  ],
  components: {
    Hero,
    WhyUsAsPartners,
    TypesOfPlantsForCompany,
    FormContactB2b,
    SectionGuarantees,
    SectionOptimisedSystem,
  },
  computed: getters(),
}
</script>

<style lang="scss">
#SolarPlantsB2b {
  .Hero {
    h1 {
      text-align: left;
    }

    .image img {
      filter: brightness(0.45);
      height: 100%;
    }
  }
}
</style>

<i18n>
{
  "lt": {
    "meta": {
      "title": {
        "complement": "Nogrid",
        "inner": "Efektyvūs saulės elektrinių sprendimai įmonėms",
        "separator": "-"
      }
    },
    "title": "Efektyvūs saulės elektrinių sprendimai įmonėms",
    "side": "Patyrusių profesionalų komanda kiekvienai įmonei parenka tinkamiausią individualų saulės elektrinių sprendimą ir užtikrina sėkminga projekto įgyvendinimą nuo projektavimo iki elektrinės priežiūros."
  }
}
</i18n>
